import { render, staticRenderFns } from "./ComponentSwitcher.vue?vue&type=template&id=726f17ec&scoped=true&"
import script from "./ComponentSwitcher.vue?vue&type=script&lang=js&"
export * from "./ComponentSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ComponentSwitcher.vue?vue&type=style&index=0&id=726f17ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f17ec",
  null
  
)

export default component.exports